import { render, staticRenderFns } from "./InformationAboutStudentMovementReport.vue?vue&type=template&id=6bd4a671&"
import script from "./InformationAboutStudentMovementReport.vue?vue&type=script&lang=js&"
export * from "./InformationAboutStudentMovementReport.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutStudentMovementReport.vue?vue&type=style&index=0&id=6bd4a671&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports